export default "__VITE_PUBLIC_ASSET__430d1b18__"